const CHECKOUT_URL = 'https://checkout.razorpay.com/v1/checkout.js';

let loadingPromise;

/** Loads Razorpay Checkout once, even if a customer retries the button. */
export function loadRazorpayCheckout() {
  if (window.Razorpay) return Promise.resolve(window.Razorpay);
  if (loadingPromise) return loadingPromise;

  loadingPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = CHECKOUT_URL;
    script.async = true;
    script.onload = () => (window.Razorpay ? resolve(window.Razorpay) : reject(new Error('Razorpay failed to load.')));
    script.onerror = () => reject(new Error('Unable to load secure checkout. Check your connection and try again.'));
    document.head.appendChild(script);
  });
  return loadingPromise;
}
